import "core-js/modules/es.array.includes.js";
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { computed } from 'vue';
import { injectListPage } from '@/share/hooks/common';
export default {
  __name: 'mg-table-actions',
  props: {
    buttons: {
      type: Array,
      default: () => ['edit', 'delete', 'options']
    },
    options: {
      type: Array,
      default: () => []
    },
    dataRow: {
      type: Object,
      default: () => null
    }
  },
  emits: ['actionClick', 'optionClick'],
  setup(__props, {
    emit: __emit
  }) {
    const $listPage = injectListPage();
    const emit = __emit;
    const handleActionClick = action => {
      emit('actionClick', action);
      if ($listPage.isSupported() && props.dataRow) {
        switch (action) {
          case 'edit':
            $listPage.editRow(props.dataRow);
            break;
          case 'delete':
            $listPage.deleteRow(props.dataRow);
            break;
        }
      }
    };
    const handleOptionClick = ({
      option
    }) => {
      emit('optionClick', {
        action: 'option',
        option
      });
    };
    const props = __props;
    const showEdit = computed(() => props.buttons.includes('edit'));
    const showDelete = computed(() => props.buttons.includes('delete'));
    const showOptions = computed(() => props.options && props.options.length > 0);
    return (_ctx, _cache) => {
      const _component_vxe_button = _resolveComponent("vxe-button");
      const _component_vxe_button_group = _resolveComponent("vxe-button-group");
      return _openBlock(), _createBlock(_component_vxe_button_group, {
        size: "mini"
      }, {
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default"), showEdit.value ? (_openBlock(), _createBlock(_component_vxe_button, {
          key: 0,
          mode: "text",
          status: "primary",
          icon: "vxe-icon-edit",
          onClick: _cache[0] || (_cache[0] = () => handleActionClick('edit'))
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("编辑", -1)]))]),
          _: 1
        })) : _createCommentVNode("", true), showDelete.value ? (_openBlock(), _createBlock(_component_vxe_button, {
          key: 1,
          mode: "text",
          status: "danger",
          icon: "vxe-icon-delete",
          onClick: _cache[1] || (_cache[1] = () => handleActionClick('delete'))
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("删除", -1)]))]),
          _: 1
        })) : _createCommentVNode("", true), showOptions.value ? (_openBlock(), _createBlock(_component_vxe_button, {
          key: 2,
          mode: "text",
          icon: "vxe-icon-menu",
          options: __props.options,
          onDropdownClick: handleOptionClick
        }, null, 8, ["options"])) : _createCommentVNode("", true)]),
        _: 3
      });
    };
  }
};